import React, { useEffect, useMemo, useState } from "react";
import { DataVerificationHeading } from "../../utils/helperData";
import { useDispatch, useSelector } from "react-redux";
import {
  DownloadDataVeridficationCSV,
  fetchDataProjectList,
  GetDataVerification,
} from "../../../redux/action/DataVerification/DataverificationAction";
import {
  TableHead,
  TableRow,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
} from "@mui/material";
import { GrDocumentCsv } from "react-icons/gr";
import Pagination from "../../customComponent/Pagination";
import { useNavigate, useParams } from "react-router";
import { ISO_WELD_LOG } from "../../utils/RouteConstant";

const ReportAnalytics = () => {
  const dispatch = useDispatch();
  const { projectId } = useParams();
   const navigate = useNavigate();
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const rowsPerPageOptions = [10, 20, 50, 100, "All"];
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const {
    dataVerificationDetails,
    dataVerificationProject,
    dataVerificationProjectDownload,
    loading: projectLoading,
  } = useSelector((state) => state.dataVerification);

  const totalCount = dataVerificationDetails?.result?.count;
  const totalPages =
    rowsPerPage === "All" ? 1 : Math.ceil(totalCount / rowsPerPage);

  const handleRowsPerPageChange = (event) => {
    const value = event.target.value;
    if (value === "All") {
      setRowsPerPage(totalCount);
      setCurrentPage(1);
    } else {
      setRowsPerPage(Number(value));
      setCurrentPage(1);
    }
  };

  const projectOptions = useMemo(
    () =>
      dataVerificationProject?.data?.data?.data?.map((project) => ({
        value: project._id,
        label: `${project?.project_name} (${project?.project_id})`,
      })) || [],
    [dataVerificationProject]
  );

  useEffect(() => {
    if (projectId) {
      dispatch(
        GetDataVerification(projectId, currentPage, searchTerm, rowsPerPage)
      );
    }
    // dispatch(fetchDataProjectList());
  }, [dispatch, currentPage, projectId, rowsPerPage, searchTerm]);

  useEffect(() => {
    if (projectId) {
      dispatch(DownloadDataVeridficationCSV(projectId));
    }
  }, [dispatch, projectId]);

  const handleExportCSV = () => {
    if (dataVerificationProjectDownload) {
      const selectedProject = projectOptions.find(
        (project) => project.value === projectId
      );
      const projectName = selectedProject
        ? selectedProject.label.split(" (")[0]
        : "unknown_project";
      const csvContent = `data:text/csv;charset=utf-8,${dataVerificationProjectDownload}`;
      const encodedUri = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", `${projectName}_data_verification.csv`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      alert("No data available to download.");
    }
  };

  const handleRowClick = (verify) => {
    navigate(`${ISO_WELD_LOG}`, {
      state: {
        data: {
          _id: verify._id,
          project_id: projectId,
        },
      },
    });
  };

  return (
    <div className="p-4">
      <div className=" justify-between items-center flex mb-4">
        <div className="text-xl font-semibold">
          Total Count: {dataVerificationDetails?.result?.count || 0}
        </div>

        {/* Export CSV Button */}
        <div>
          {dataVerificationDetails?.result?.count > 0 ? (
            <div className="flex justify-end">
              <button
                onClick={handleExportCSV}
                className="bg-green-600 hover:bg-green-700 text-white font-semibold py-2 px-4 rounded flex items-center space-x-2"
              >
                <GrDocumentCsv className="text-white text-xl" />
                <span>Export CSV</span>
              </button>
            </div>
          ) : (
            <></>
          )}
        </div>
      </div>
      <div className="flex justify-center overflow-auto mt-2">
        <TableContainer
          component={Paper}
          sx={{
            width: "100%",
            maxWidth: "100%",
            height: "100%",
            overflow: "auto",
            border: "1px solid #ccc",
            borderRadius: "10px",
          }}
        >
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                {DataVerificationHeading.map((header, index) => (
                  <TableCell
                    key={index.name}
                    sx={{
                      fontWeight: "600",
                      fontSize: "16px",
                      color: "rgb(75 85 99)",
                      backgroundColor: "rgb(243, 244, 246)",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      padding: "16px 12px",
                    }}
                  >
                    {header?.name}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {dataVerificationDetails?.result?.data?.length > 0 ? (
                <>
                  {dataVerificationDetails?.result?.data?.map((verify, i) => (
                    <TableRow
                      hover
                      onClick={() => handleRowClick(verify)}
                      key={i}
                      sx={{
                        "&:hover": { backgroundColor: "#e0e0e0" },
                        color: "text-gray-50062",
                        fontSize: "12px",
                        cursor: "pointer",
                      }}
                    >
                      <TableCell>{verify?.formName || "-"}</TableCell>
                      <TableCell>{verify?.drawingNumber || "-"}</TableCell>
                      <TableCell>{verify?.system || "-"}</TableCell>
                      <TableCell>{verify?.fieldName || "-"}</TableCell>
                      <TableCell>{verify?.exceptionData || "-"}</TableCell>
                      <TableCell>{verify?.error || "-"}</TableCell>
                      <TableCell>{verify?.inspectorName || "-"}</TableCell>
                      <TableCell>
                        {verify?.inspectionDate
                          ? new Date(verify?.inspectionDate).toLocaleDateString(
                              "en-US",
                              {
                                month: "2-digit",
                                day: "2-digit",
                                year: "numeric",
                              }
                            )
                          : "-"}
                      </TableCell>
                      <TableCell>
                        {verify?.modifiedDate
                          ? new Date(verify?.modifiedDate).toLocaleDateString(
                              "en-US",
                              {
                                month: "2-digit",
                                day: "2-digit",
                                year: "numeric",
                              }
                            )
                          : "-"}
                      </TableCell>
                    </TableRow>
                  ))}
                </>
              ) : (
                <tr>
                  <td colSpan="8" className="px-6 py-4 text-center">
                    <div className="flex flex-col items-center justify-center">
                      <img
                        src="https://img.freepik.com/premium-vector/no-data-concept-illustration_86047-488.jpg?semt=ais_hybrid"
                        alt="No Data"
                        className="mb-4 w-[200px] h-[200px]"
                      />
                      <p className="text-lg text-gray-500">
                        No Inspector created.
                      </p>
                      <p className="text-sm text-gray-400">
                        Please check back later or data.
                      </p>
                    </div>
                  </td>
                </tr>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
      <div className="flex items-center justify-end mb-4 space-x-3">
        <div className="flex items-center mt-6 ">
          <label htmlFor="rows-per-page" className="mr-2">
            Rows per page:
          </label>
          <select
            id="rows-per-page"
            value={rowsPerPage}
            onChange={handleRowsPerPageChange}
            className="border border-solid border-2 h-[34px] rounded p-1 text-gray-500"
          >
            {rowsPerPageOptions.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
        </div>

        {totalPages > 1 && rowsPerPage !== "All" && (
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={setCurrentPage}
          />
        )}
      </div>
    </div>
  );
};

export default ReportAnalytics;